import { useState } from 'react';
import CardsLayer from "../../components/dashboardComponents/ProductsComponents/CardsLayer";
import TopLayer from "../../components/dashboardComponents/ProductsComponents/TopLayer";

const ProductsPage = () => {
  const [filter, setFilter] = useState({ type: 'Product' });
  const [dateRange, setDateRange] = useState({ from: null, to: null });

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
  };

  const handleDateRangeChange = (from, to) => {
    setDateRange({ from, to });
  };

  return (
    <div className="p-6 bg-bg-main min-h-screen">
      <TopLayer 
        onFilterChange={handleFilterChange}
        onDateRangeChange={handleDateRangeChange}
      />
      <CardsLayer filter={filter} dateRange={dateRange} />
    </div>
  );
};

export default ProductsPage;